import { dashboardFetch } from 'api/dashboard/dashboard.js'
import Loader from 'components/common/Loader.js'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

function Layout () {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)
  document.title = 'Dashboard'

  useEffect(() => {
    dashboardView()
  }, [])

  // const hasData = data && Object.keys(data).length > 0;

  const dashboardView = async () => {
    try{
      setLoading(true)
      const res = await dashboardFetch()
      setData(res.data)
    } catch(error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch the dashboard data')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-content">
      {loading ? <Loader/> :
        (
          <div className="dashboard-stats">

            <div className="stat-card orders">
              <div className="icon">
                <i className="ri-file-paper-fill"></i>
              </div>
              <div className="details">
                <h5>Total Orders</h5>
                <div className="count">{data?.totalOrdersCount}</div>
              </div>
            </div>

            <div className="stat-card users">
              <div className="icon">
                <i className="ri-group-fill"></i>
              </div>
              <div className="details">
                <h5>Active Users</h5>
                <div className="count">{data?.totalActiveUsers}</div>
              </div>
            </div>

            <div className="stat-card revenue">
              <div className="icon">
                <i className="ri-coins-line"></i>
              </div>
              <div className="details">
                <h5>Total Value</h5>
                <div className="count">{data?.totalOrderValue?.toLocaleString()}</div>
              </div>
            </div>

            {/* <div className="stat-card couriers">
              <div className="icon">
                <i className="ri-truck-line"></i>
              </div>
              <div className="details">
                <h5>Active Couriers</h5>
                <div className="count">{data?.totalCourierCount}</div>
              </div>
            </div> */}
          </div>
        )
      }
    </div>

  );
}

export default Layout